<template>
  <div class="box">
    <div class="desc">{{data}}</div>
  </div>
</template>

<script>
export default {
  name: "TestDescription",
  props: {
    data: {type: String}
  }
}
</script>

<style scoped>
  .box{
    text-align: center;
    font-size: var(--ecs-font-md);
    line-height: 1.3;
    margin-bottom: clamp(0.25rem, 0.8vw, 0.5rem);
  }
  .desc{
    display: inline-block;
    text-align: justify;
  }
</style>
